<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- contactsInformation -->
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- alert -->
            <div
              class="sm:tw-w-1/2 md:tw-w-2/3 xl:tw-w-1/2 alert alert-primary"
            >
              <div class="tw-flex tw-items-center tw-mb-2">
                <span class="tw-mx-2">●</span>
                <p class="tw-font-medium m-0">
                  {{ pageVocabs + "messages.description" | translate }}
                </p>
              </div>
            </div>

            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/2"></div>

            <!-- firstName -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.firstName"
                [control]="form?.get('firstName')"
                label="common.firstName"
                [maxLength]="32"
              >
              </form-field>
            </div>
            <!--lastName-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.lastName"
                [control]="form?.get('lastName')"
                label="common.lastName"
                [maxLength]="64"
              >
              </form-field>
            </div>

            <!--cellphone-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.cellPhone"
                [control]="form?.get('cellPhone')"
                [label]="'common.mobile'"
                [isMobileField]="true"
                [maxLength]="12"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!--telephone-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.telephone"
                [control]="form?.get('telephone')"
                [label]="'common.phone' | translate"
                [maxLength]="11"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!--email-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.email"
                [control]="form?.get('email')"
                label="common.email"
                [maxLength]="128"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!--job-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.job"
                [control]="form?.get('job')"
                [label]="fields + 'job' | translate"
                [maxLength]="64"
              >
              </form-field>
            </div>

            <!--address-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/2">
              <form-textarea
                class="tw-w-full"
                label="common.address"
                [(value)]="model.address"
                [control]="form?.get('address')"
                [rows]="2"
                maxlength="255"
              >
              </form-textarea>
            </div>
            <!--gender-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <mat-button-toggle-group
                matInput
                [(ngModel)]="model.gender"
                formControlName="gender"
              >
                <span
                  class="tw-font-medium tw-self-center tw-px-[11px] tw-text-gray-700 dark:tw-text-gray-200"
                  >{{ "common.gender" | translate }}
                </span>
                <!-- male -->
                <mat-button-toggle [value]="genderType.Man">
                  {{ "common.male" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-400">man</mat-icon>
                </mat-button-toggle>
                <!-- female -->
                <mat-button-toggle [value]="genderType.Woman">
                  {{ "common.female" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-400"
                    >woman</mat-icon
                  >
                </mat-button-toggle>
                <!-- unknown -->
                <mat-button-toggle [value]="genderType.All">
                  {{ "common.unknown" | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="true"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
